module.exports = __webpack_public_path__ + "img/error.4fec139f.svg";